import { useQuery } from "@tanstack/react-query";
import { incomeStatementService } from "~/services/contabilidad/incomeStatementService";
import type { IncomeStatementFilters } from "~/types/contabilidad";

export const INCOME_STATEMENT_QUERY_KEY = ["income-statement"];

export function useIncomeStatement(filters: IncomeStatementFilters) {
  return useQuery({
    queryKey: [...INCOME_STATEMENT_QUERY_KEY, filters],
    queryFn: () => incomeStatementService.getIncomeStatement(filters),
    enabled:
      !!filters.year &&
      !!filters.month &&
      !!filters.companyId &&
      !!filters.templateId,
  });
}
